import PropTypes from "prop-types"
import React from "react"

import MiscBarometer from "./barometer"
import MiscPercentage from "./percentage"

import CpiImage from "../../../assets/icons/cpi.png"
import GdpImage from "../../../assets/icons/gdp.png"
import WpiImage from "../../../assets/icons/wpi.png"
import GenderImage from "../../../assets/icons/gender.png"
import RemSentimentImage from "../../../assets/icons/rem-sentiment.png"
import UnemploymentImage from "../../../assets/icons/unemployment.png"
import NewHireImage from "../../../assets/icons/new-hire.png"

const Misc = ({ blocks, data, animate }) => (
  <div className="col col-12 mt2 mb2">
    <div className="mxn1">
      <div className="lg-flex flex-stretch col col-12">
        <div className="col col-12 lg-col-3 mb2 px1">
          <MiscBarometer
            block={blocks.barometer}
            values={{
              contraction: data.barometer.contraction.value,
              stable: data.barometer.stable.value,
              expansion: data.barometer.expansion.value,
            }}
            animate={animate}
          />
        </div>
        <div className="col col-12 lg-col-3 mb2 px1">
          <MiscPercentage
            background={true}
            block={blocks.genderPayIndex}
            value={data.genderPayIndex.value}
            icon={GenderImage}
            animate={animate}
          />
        </div>
        <div className="col col-12 lg-col-3 mb2 px1">
          <MiscPercentage
            background={true}
            block={blocks.remunerationSentimentIndex}
            value={data.remunerationSentimentIndex.value}
            icon={RemSentimentImage}
            animate={animate}
          />
        </div>
        <div className="col col-12 lg-col-3 mb2 px1">
          <MiscPercentage
            background={true}
            block={blocks.newHirePayRates}
            value={data.newHirePayRates.value}
            icon={NewHireImage}
            animate={animate}
          />
        </div>
      </div>
      <div className="px1">
        <div className="col col-12 bg-mercer-glass-dark">
          <div className="col col-12 mt2 center">
            <h3 className="mt0 mb0 fg-mercer-gray-dark uppercase letter-space-1.5">{blocks.keyEconomicIndicators.title}</h3>
          </div>
          <div className="lg-flex flex-stretch col col-12">
            <div className="col col-12 lg-col-3 mb2 px1">
              <MiscPercentage
                block={blocks.gdp}
                learnMore={false}
                value={data.gdp.value}
                italic={true}
                icon={GdpImage}
                animate={animate}
              />
            </div>
            <div className="col col-12 lg-col-3 mb2 px1">
              <MiscPercentage
                block={blocks.wpi}
                learnMore={false}
                value={data.wpi.value}
                italic={true}
                icon={CpiImage}
                animate={animate}
              />
            </div>
            <div className="col col-12 lg-col-3 mb2 px1">
              <MiscPercentage
                block={blocks.cpi}
                learnMore={false}
                value={data.cpi.value}
                italic={true}
                icon={WpiImage}
                animate={animate}
              />
            </div>
            <div className="col col-12 lg-col-3 mb2 px1">
              <MiscPercentage
                block={blocks.unemployment}
                learnMore={false}
                value={data.unemployment.value}
                italic={true}
                icon={UnemploymentImage}
                animate={animate}
              />
            </div>
          </div>
          <div className="col col-12 px3 center fg-mercer-gray-dark line-height-2 mtn2">
            <p>{blocks.keyEconomicIndicators.content}</p>
            <div className="col col-12 mt1">
              <small className="fg-mercer-gray-mid italic">Source: ABS catalogues 5206.0, 6401.0, 6202.0, 6345.0</small>
            </div>
          </div>
          <div className="col col-12 mt2 mb2 center">
            <a href={blocks.keyEconomicIndicators.link1} target="_parent" className="btn btn-primary bg-mercer-gray-light fg-mercer-gray-dark">Learn More ></a>
          </div>
        </div>
      </div>
      <div className="col col-12 mt2 center">
        <small className="fg-mercer-gray-mid italic">While every care has been taken to ensure the accuracy of the information, no warranty is given in respect thereof<br />&copy; Mercer LLC, All Rights Reserved.</small>
      </div>
    </div>
  </div>
)

const blockType = PropTypes.shape({
  title: PropTypes.string,
  content: PropTypes.string,
  link1: PropTypes.string,
})

Misc.propTypes = {
  blocks: PropTypes.shape({
    barometer: blockType,
    genderPayIndex: blockType,
    remunerationSentimentIndex: blockType,
    newHirePayRates: blockType,
    gdp: blockType,
    cpi: blockType,
    wpi: blockType,
    unemployment: blockType,
    keyEconomicIndicators: blockType,
  }),
  data: PropTypes.shape({
    barometer: PropTypes.shape({
      contraction: PropTypes.object,
      stable: PropTypes.object,
      expansion: PropTypes.object,
    }),
    genderPayIndex: PropTypes.object,
    remunerationSentimentIndex: PropTypes.object,
    newHirePayRates: PropTypes.object,
    gdp: PropTypes.object,
    cpi: PropTypes.object,
    wpi: PropTypes.object,
    unemployment: PropTypes.object,
  }),
  animate: PropTypes.bool,
}

Misc.defaultProps = {
  blocks: null,
  data: null,
  animate: true,
}

export default Misc
